/**
 * Whether the current user can tag messages with initiatives in a channel.
 * Allowed: company admins, group admins, and channel writers.
 */
export default function canTagInitiative(channel, isCompanyAdmin) {
  if (isCompanyAdmin) return true;
  if (!channel) return false;
  return Boolean(channel.isAdmin || channel.canWriteAsChannel);
}
